var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourInternshipApply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-678 -3102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-569 -1866)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1247 4968)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(578.98 3038.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.99,584.34a4.64,4.64,0,1,0,4.64,4.64A4.64,4.64,0,0,0,552.99,584.34Zm0,7.424a2.784,2.784,0,1,1,2.784-2.784A2.787,2.787,0,0,1,552.99,591.764Z",
    transform: "translate(-427.208 -498.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.113,480.539H232v1.3h-1.3v1.114H232v1.3h1.114v-1.3h1.3v-1.114h-1.3ZM219.58,474.98h5.568v1.856H219.58Z",
    transform: "translate(-106.78 -392.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.863,80.188h14.86v4.554h1.856V74.589a1.841,1.841,0,0,0-1.839-1.839h-.694a1.793,1.793,0,0,0-1.672,1.081.48.48,0,0,1-.851,0,1.793,1.793,0,0,0-1.672-1.081h-.461a1.793,1.793,0,0,0-1.672,1.081.48.48,0,0,1-.851,0,1.793,1.793,0,0,0-1.672-1.081h-.442a1.793,1.793,0,0,0-1.672,1.081.48.48,0,0,1-.851,0,1.793,1.793,0,0,0-1.672-1.081h-.7a1.841,1.841,0,0,0-1.839,1.839V95.02H120.2V93.164h-8.325Zm.655-5.64a2.314,2.314,0,0,0,2.138,1.422,2.253,2.253,0,0,0,2.1-1.365l.4-.058a2.314,2.314,0,0,0,2.138,1.422,2.253,2.253,0,0,0,2.1-1.365l.42-.058a2.314,2.314,0,0,0,2.138,1.422,2.253,2.253,0,0,0,2.1-1.365l.677-.017v3.743H111.862l0-3.726Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourInternshipApply);
export default __webpack_public_path__ + "static/media/your-internship-apply.1e6386bc90c7ce370f0d92f175cde7db.svg";
export { ForwardRef as ReactComponent };